<template>
    <TsCard
        :append-class="twMerge('flex p-0 rounded-lg', direction === 'vertical' ?
         'flex-col max-w-sm' : 'flex-row', centered ? 'p-6':'', appendClass)"
        :dataTestid="dataTestid">
        <TsImage v-if="image" class="rounded-t-lg" :src="image" :alt="alt" :width="imageWidth" :height="imageHeight" :data-testid="`${dataTestid}-image`" loading="lazy"/>
        <div :class="{ 'p-5': !centered }">
            <TsTypography :variant="variant" :data-testid="`${dataTestid}-title`">{{ title }}</TsTypography>
            <p v-html="description" :data-testid="`${dataTestid}-description`"></p>
            <div class="mt-2">
                <slot>
                    <TsButton :data-testid="`${dataTestid}-button`" v-if="buttonLabel" @click="emit('button-click')">{{ buttonLabel }}</TsButton>
                </slot>
            </div>
        </div>
    </TsCard>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const emit = defineEmits(['button-click'])

const Variants = ["h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol", "li", "base", "sm", "xs", "xxs", "NuxtLink"] as const;

type Props = {
    dataTestid?: string;
    title?: string;
    variant?: (typeof Variants)[number];
    image?: string;
    alt?: string | number;
    imageWidth?: number;
    imageHeight?: number;
    buttonLabel?: string;
    description?: string;
    direction: 'horizontal' | 'vertical';
    centered: boolean;
    appendClass?: string;
};
const props = withDefaults(defineProps<Props>(), {
    title: "Noteworthy technology acquisitions 2021",
    description:
        "Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
    direction: 'vertical'
});
</script>
